import { useTranslation } from "react-i18next";

export default function WaitingApproval() {
    const { t } = useTranslation();
    return (
        <>
            <div className="text-center " style={{ minHeight: '400px' }}>

                <div className="form-card card mb-4" style={{marginTop:'30px'}}>
                    <div className="card-body">
                        <div className="step-heading">
                            <h2 className="fw-bold">{t("waitingApproval.thank_you")}</h2>
                        </div>
                        <div className="step-dec">
                            <p className="m-0">{t("waitingApproval.application_received")}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}